import { FC, useEffect, useState } from 'react'
import { TablesWidget } from '../../../../../../_metronic/partials/widgets'
import { KTIcon } from '../../../../../../_metronic/helpers'
import { TableSearchComponent } from '../../../../../../_metronic/partials/widgets/search-input/TableSearchComponent'
import { DateFormat } from '../../../../../../_metronic/helpers/components/DateFormat'
import { Button, Popover, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useTheme } from '../../../../../../_metronic/partials/layout/app-theme/ThemeContext'
import Table from '../../common/Table'
import TableHeader from '../../common/TableHeader'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../../../../redux/store'
import { deleteCouponApi, getCouponListApi } from '../../../../../redux/slices/CouponSlice'
import { toast } from 'react-toastify'
import DownloadCouponModal from './DownloadCouponModal'
const CouponTable: FC = () => {
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchKey, setSearchKey] = useState('')
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('')
  const [selectedRow, setSelectedRow] = useState([])
  const [showDownloadModal, setShowDownloadModal] = useState(false)
  const [selectedCouponId, setSelectedCouponId] = useState<number | null>(null)
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { theme } = useTheme()

  const couponSelectorData = useSelector(
    (state: RootState) => state.coupon.CouponList?.data?.data || []
  )
  const couponSelectorTotal = useSelector(
    (state: RootState) => state.coupon.CouponList?.data?.total || 0
  )

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedSearchQuery(searchKey)
    }, 1000)

    return () => clearTimeout(debounceTimeout)
  }, [searchKey])

  const fetchCouponListGetApi = () => {
    setLoading(true)

    dispatch(
      getCouponListApi({
        pageNumber: currentPage,
        pageSize: rowsPerPage,
        filterkey: debouncedSearchQuery,
      })
    )
      .then((value: any) => {
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchCouponListGetApi()
  }, [currentPage, rowsPerPage, debouncedSearchQuery])

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setDebouncedSearchQuery(searchKey)
    }, 1000)

    return () => clearTimeout(debounceTimeout)
  }, [searchKey])

  // Actions
  const handleEdit = (id: any) => {
    navigate(`edit/${id}`)
  }

  const handleView = async (id: any) => {
    try {
      const response: any = await dispatch(
        getCouponListApi({
          pageNumber: currentPage,
          pageSize: rowsPerPage,
          filterkey: "",
        })
      );

      const selectedCoupon = response.payload?.data?.data?.find((coupon: any) => coupon.id === id);
      const coupon_qr_codes_url = selectedCoupon?.coupon_qr_codes_url;

      if (coupon_qr_codes_url) {
        window.open(coupon_qr_codes_url, "_blank");
      } else {
        toast.error("PDF file not found");
      }
    } catch (error) {
      toast.error("Error fetching Coupon QR Codes data");
    }
  };

  const handleDelete = (id: any) => {
    dispatch(deleteCouponApi(id)).then((response: any) => {
      if (response.payload.success) {
        toast.success(response.payload.reason)
        fetchCouponListGetApi()
      } else {
        toast.error(response.payload.reason || 'Something went wrong')
      }
    })
  }

  const handleDownload = (id: any) => {
    setSelectedCouponId(id)
    setShowDownloadModal(true)
  }

  const handleCloseDownloadModal = () => {
    setShowDownloadModal(false)
    setSelectedCouponId(null)
  }



  const handleSearchChange = (searchQuery: string) => {
    setSearchKey(searchQuery)
  }

  const handlePageChange = (page: number) => {
    setCurrentPage(page)
  }

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setCurrentPage(page)
    setRowsPerPage(newPerPage)
  }

  const columnData = [
    {
      name: 'Name',
      selector: (row: any) => row?.name,
      cell: (row: any) => <span className='fw-bold text-gray-800'>{row?.name}</span>,
      sortable: true,
    },
    {
      name: 'Product',
      selector: (row: any) => row?.product?.name || '',
      cell: (row: any) => {
        const product = row?.product
        const productName = product?.name || 'N/A'
        const productImage = product?.product_image
        const useLimit = row?.use_limit ?? 0

        return (
          <div className='d-flex align-items-center gap-2'>
            {/* Product Icon */}
            {productImage ? (
              <img
                src={productImage}
                alt={productName}
                style={{
                  width: '32px',
                  height: '32px',
                  objectFit: 'cover',
                  borderRadius: '6px',
                  flexShrink: 0,
                }}
                onError={(e) => {
                  e.currentTarget.style.display = 'none'
                  const fallbackIcon = e.currentTarget.nextElementSibling as HTMLElement
                  if (fallbackIcon) {
                    fallbackIcon.style.display = 'inline-block'
                  }
                }}
              />
            ) : null}
            {!productImage && (
              <i className='bi bi-box-seam text-primary fs-4' style={{ flexShrink: 0 }} />
            )}
            
            {/* Use Limit Value */}
            <div className='d-flex flex-column'>
              <div className='d-flex align-items-center'>
                <i className='bi bi-ticket-perforated text-muted me-2 fs-7' />
                <span className='text-gray-600 fw-semibold fs-7'>
                 <span className='text-gray-800 fw-bold'>{useLimit}</span>
                </span>
              </div>
              
              {/* Product Name Button */}
              <button
                className='btn btn-sm btn-light-primary d-inline-flex align-items-center gap-1 mt-1'
                style={{
                  width: 'fit-content',
                  padding: '4px 8px',
                }}
              >
                {productImage ? (
                  <img
                    src={productImage}
                    alt={productName}
                    style={{
                      width: '16px',
                      height: '16px',
                      objectFit: 'cover',
                      borderRadius: '3px',
                    }}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none'
                      const fallbackIcon = e.currentTarget.nextElementSibling as HTMLElement
                      if (fallbackIcon) {
                        fallbackIcon.style.display = 'inline-block'
                      }
                    }}
                  />
                ) : (
                  <i className='bi bi-box-seam fs-7' />
                )}
                {!productImage && <i className='bi bi-box-seam fs-7' style={{ display: 'none' }} />}
                <span className='fw-semibold'>{productName}</span>
              </button>
            </div>
          </div>
        )
      },
      sortable: true,
    },
    {
      name: 'Coupon Type',
      selector: (row: any) => row?.coupon_type,
      cell: (row: any) => {
        const type = row?.coupon_type || ''
        let badgeClass = 'badge-light-secondary'
        if (type === 'money') badgeClass = 'badge-light-success'
        if (type === 'points') badgeClass = 'badge-light-info'
        if (type === 'both') badgeClass = 'badge-light-primary'
        return (
          <span className={`badge ${badgeClass} fw-bold`}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </span>
        )
      },
      sortable: true,
    },
    {
      name: 'Coupon Value',
      cell: (row: any) => (
        <div className='d-flex flex-column py-2'>
          <div className='mb-1'>
            <i className='bi bi-wallet2 text-info me-2' />
            <span className='text-gray-600 fw-semibold fs-7'>Points: {row?.coupon_points || 0}</span>
          </div>
          <div>
            <i className='bi bi-currency-rupee text-success me-2' />
            <span className='text-dark fw-semibold fs-7'>
              Money: {row?.coupon_money ? `${Number(row?.coupon_money).toFixed(2)}` : '0.00'}
            </span>
          </div>
        </div>
      ),
      sortable: false,
    },
    {
      name: 'Validity',
      cell: (row: any) => (
        <div className='d-flex flex-column py-2'>
          <div className='mb-1'>
            <i className='bi bi-calendar-check text-primary me-2' />
            <span className='text-gray-600 fw-semibold fs-7'>
              Start: {row?.start_date ? new Date(row?.start_date).toLocaleDateString() : 'N/A'}
            </span>
          </div>
          <div>
            <i className='bi bi-calendar-x text-danger me-2' />
            <span className='text-gray-600 fw-semibold fs-7'>
              End: {row?.end_date ? new Date(row?.end_date).toLocaleDateString() : 'N/A'}
            </span>
          </div>
        </div>
      ),
      sortable: false,
    },
    {
      name: 'Status',
      selector: (row: any) => row?.is_active,
      cell: (row: any) => (
        <span
          className={`badge ${row?.is_active ? 'badge-light-success' : 'badge-light-danger'} fw-bold`}
        >
          {row?.is_active ? 'Active' : 'Inactive'}
        </span>
      ),
      sortable: true,
    },
    {
      name: 'Created At',
      selector: (row: any) => row?.created_at,
      cell: (row: any) => (
        <span className='fw-semibold text-gray-600'>
          {new Date(row?.created_at).toLocaleDateString()}
        </span>
      ),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row: any) => (
        <div className='d-flex align-items-center gap-2'>
          <OverlayTrigger placement='top' overlay={<Tooltip>Download Coupon</Tooltip>}>
            <button
              className='btn btn-icon btn-light-info btn-sm'
              onClick={() => handleDownload(row?.id)}
              style={{
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px',
              }}
            >
              <i className='fa-solid fa-download fs-6'></i>
            </button>
          </OverlayTrigger>

          <OverlayTrigger placement='top' overlay={<Tooltip>Edit Coupon</Tooltip>}>
            <button
              className='btn btn-icon btn-light-primary btn-sm'
              onClick={() => handleEdit(row?.id)}
              style={{
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px',
              }}
            >
              <i className='bi bi-pencil fs-6'></i>
            </button>
          </OverlayTrigger>

          <OverlayTrigger placement='top' overlay={<Tooltip>Delete Coupon</Tooltip>}>
            <button
              className='btn btn-icon btn-light-danger btn-sm'
              onClick={() => handleDelete(row?.id)}
              style={{
                width: '35px',
                height: '35px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '6px',
              }}
            >
              <i className='bi bi-trash fs-6'></i>
            </button>
          </OverlayTrigger>
        </div>
      ),
      sortable: false,
    },
  ]

  return (
    <>
      <div className='card'>
        <TableHeader
          search={searchKey}
          addButtonText={'Add Coupon'}
          handleSearchChange={handleSearchChange}
          handleAddButton={() => navigate('add')}
          showFilter={true}
          // additionalButtons={[
          //   {icon: 'bi-pencil', tooltip: 'Edit', onClick: () => console.log('Edit clicked')},
          // ]}
          filterContent={
            <div>
              <p>Custom filter form</p>
              <div className='d-flex justify-content-end'>
                <Button variant='secondary' className='me-2'>
                  Close
                </Button>
                <Button variant={`${theme}`}>Apply Filters</Button>
              </div>
            </div>
          }
        />

        <div className='card-body p-0 shadow-sm'>
          <Table
            data={couponSelectorData}
            columns={columnData}
            isLoading={loading}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            totalRows={couponSelectorTotal}
            showPagination={true}
            onRowClicked={(row) => {
              console.log(row)
            }}
            selectableRows
            onSelectedRowsChange={(selected) => {
              setSelectedRow(selected.selectedRows)
            }}
          />
        </div>
      </div>

      {/* Download Coupon Modal */}
      <DownloadCouponModal
        show={showDownloadModal}
        onHide={handleCloseDownloadModal}
        couponId={selectedCouponId}
      />
    </>
  )
}

export default CouponTable